import { petDefaultIdCardImage } from '@/shared/assets'

const SUBTITLE_SEPARATOR = ' · '

export type ClaimCardTone = 'info' | 'success' | 'warning' | 'error' | 'neutral'

const TONE_CLASS_NAME: Record<ClaimCardTone, string> = {
  info: 'bg-indigo-50 text-indigo-base',
  success: 'bg-success-100 text-success-base',
  warning: 'bg-warning-50 text-warning-600',
  error: 'bg-error-50 text-error-base',
  neutral: 'bg-neutral-50 text-neutral-600',
}

export function getClaimToneClassName(tone: ClaimCardTone): string {
  return TONE_CLASS_NAME[tone]
}

export function useClaimCard({
  petPictureUrl,
  statusTone,
  claimNumber,
  date,
}: {
  petPictureUrl?: string
  statusTone: ClaimCardTone
  claimNumber?: string
  date?: string
}) {
  const subtitle = [claimNumber, date].filter(Boolean).join(SUBTITLE_SEPARATOR)
  return {
    // The API can send an empty string when the pet has no picture
    petImageUrl: petPictureUrl || petDefaultIdCardImage,
    statusClassName: getClaimToneClassName(statusTone),
    subtitle,
  }
}
